export default __webpack_public_path__ + "static/media/nodejs-icon.dc0b9794.png";